import axios from "axios";
import api from "./api";

const baseURLAPI = process.env.REACT_APP_API_HOST;

export const dnsLookup = async (
  domain: string,
  options?: { signal?: AbortSignal }
): Promise<boolean> => {
  const uri = `${baseURLAPI}/Account/VerifyEmailDomain?domain=${domain}`;

  try {
    const response = await api.head(uri, { signal: options?.signal });

    if (response.status === 200) {
      return true;
    }
  } catch (error) {
    if (axios.isCancel(error)) throw error;
  }

  return false;
};

export const getIP = async () => {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), 3000);

  try {
    const response = await fetch("https://geolocation-db.com/json/", {
      signal: controller.signal,
    });
    clearTimeout(id);

    const data = await response.json();
    return data.IPv4;
  } catch (error) {
    console.error("Ocurrió un error al obtener la dirección IP:", error);
  }
};
